import React, { useState } from 'react';
import { notification } from 'antd';

import { creditHttp } from '@network';
import { Document, DocumentStatus } from '@types';
import { axiosErrorToString, rbac, ROLES } from '@utils';
import { SwitcherControllerInput } from '@components/inputs/SwitcherControlledInput';

interface Props {
  creditId: number;
  document?: Document;
  setDocument: (document: Document) => void;
  editable: boolean;
}

export const DocumentStatuses = ({
  creditId,
  document,
  setDocument,
  editable,
}: Props) => {
  const [status, setStatus] = useState<DocumentStatus | undefined>(document?.status);
  const [loading, setLoading] = useState(false);
  if (!document) return null;

  const changeStatus = async () => {
    if (!document || !editable || loading) return;
    const nextStatus = document.isReady ? DocumentStatus.DOCS_SENT : DocumentStatus.DOCS_READY;
    setLoading(true);

    try {
      const updatedDocument = await creditHttp.changeDocumentStatus({
        creditId,
        document,
        status: nextStatus,
      });
      notification.success({ message: 'Status is updated' });
      setDocument(updatedDocument);
      setStatus(nextStatus);
    } catch (err) {
      notification.error({ message: axiosErrorToString(err) });
    } finally {
      setLoading(false);
    }
  };

  const hasDocRevisionRole = rbac.hasDocRevisionRole();

  return (
    <SwitcherControllerInput
      defaultValue={document.isReady}
      onChange={changeStatus}
      labelLeft="Pending Revision"
      labelRight="Docs Ready"
      isFixed={!hasDocRevisionRole}
      disabled={!editable}
      isFixedText={`Role is required: ${ROLES.DOC_REVISION}`}
    />
  );
};
